import { Directive, ElementRef, Input, OnDestroy, AfterViewInit } from "@angular/core";
import { CustomGalleryImageComponent } from "../../dialog-components/image-gallery/custom-gallery-image/custom-gallery-image.component";

@Directive({
  selector: "[appImageLazyLoad]",
  standalone: false,
})
export class ImageLazyLoadDirective implements AfterViewInit, OnDestroy {
  @Input("appImageLazyLoad") imageUrl!: string;

  @Input() customGalleryImage!: CustomGalleryImageComponent; // Instancia de CustomGalleryImageComponent

  @Input() imageContainer!: ElementRef;

  private observer!: IntersectionObserver;

  constructor() {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.customGalleryImage) {
          this.customGalleryImage.loadImageLazy(this.imageUrl);
          this.observer.unobserve(this.imageContainer.nativeElement);
        }
      });
    });

    this.observer.observe(this.imageContainer.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
